<script setup>
import HeaderNav from "@/layout/HeaderNav.vue";
import FooterBar from "@/layout/FooterBar.vue";
import ShortcutMenu from "@/layout/ShortcutMenu.vue";
import DashboardLeftMenu from "@/layout/DashboardLeftMenu.vue";
import {ref, watch} from "vue";
import {useSystem} from "../../store/system"

const systemStore = useSystem()

</script>

<template>
  <div class="">
    <el-container>
      <el-header height="80px" class="!tw-px-[0px]">
        <HeaderNav :only-show-bottom="true"></HeaderNav>
      </el-header>
      <el-container style="height: calc(100vh - 85px)" v-if="!systemStore.getIsMobile">
        <el-aside width="200px" class="menu-shadow menu-custom md:tw-hidden lg:tw-block">
          <DashboardLeftMenu></DashboardLeftMenu>
        </el-aside>
        <el-container>
          <main class="tw-overflow-y-auto tw-p-[2rem] " style="height: calc(100vh - 85px - 70px)">
            <router-view v-slot="{ Component }">
              <keep-alive>
                <component :is="Component" />
              </keep-alive>
            </router-view>
          </main>
          <el-footer class="!tw-px-[0px]">
            <FooterBar :only-show-bottom="true"></FooterBar>
          </el-footer>
        </el-container>
      </el-container>
      <el-container v-else>
        <main class="draw-box tw-overflow-y-auto tw-p-[2rem]" id="draw-box" style="height: calc(100vh - 85px - 70px)">
          <DashboardLeftMenu></DashboardLeftMenu>
          <router-view v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </main>
        <el-footer class="!tw-px-[0px]">
          <FooterBar :only-show-bottom="true"></FooterBar>
        </el-footer>
        <ShortcutMenu></ShortcutMenu>
      </el-container>
    </el-container>
<!--    <HeaderNav></HeaderNav>-->
<!--    &lt;!&ndash; 主要内容区域 &ndash;&gt;-->
<!--    <main>-->
<!--      <router-view v-slot="{ Component }">-->
<!--        <keep-alive>-->
<!--          <component :is="Component" />-->
<!--        </keep-alive>-->
<!--      </router-view>-->
<!--    </main>-->

<!--    &lt;!&ndash; 页脚 &ndash;&gt;-->
<!--    <FooterBar :only-show-bottom="true"></FooterBar>-->
  </div>
</template>

<style lang="scss">
.menu-custom::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  height: 0 !important;
  -webkit-appearance: none;
  background: transparent;
}
.menu-shadow {
  border-right: 1px solid $p-border-color !important;
  box-shadow: 2px 0px 15px $p-shadow-color !important;
}
</style>
